module.exports = __webpack_public_path__ + "static/media/beep-start.62ab089f.wav";